import React from "react";
import {useQuestions} from "../question/useQuestions";
import {useCurrentQuestion} from "../question/useCurrentQuestion";
import {createUseStyles} from "react-jss";
import {useNavigation} from "./useNavigation";
import {useView} from "../quiz/useView";

const useStyles = createUseStyles((theme) => ({
    dots: {
        display: "flex",
    },
    dot: {
        backgroundColor: theme.colors.satinLinen,
        width: "24px",
        height: "24px",
        margin: "0 8px",
        borderRadius: "48px",
        opacity: 0.3,
        cursor: "pointer",
        outline: "none",
        border: "none",
        padding: 0,
        "&.selected": {
            opacity: 1,
        },
        "&:focus-visible": {
            outline: "3px solid #ffffff",
            outlineOffset: "3px",
        },
    },
}));

export const Dots = () => {
    const questions = useQuestions() || [];
    const question = useCurrentQuestion();
    const classes = useStyles();
    const {navigateToIndex} = useNavigation();
    const {quizPage} = useView();

    return (
        <div className={classes.dots}>
            {questions.map((q, idx) => {
                const isSelected = quizPage && q.uniqueId === question?.uniqueId;

                const handleClick = () => {
                    if (quizPage) {
                        navigateToIndex(idx);
                    }
                };

                const handleKeyDown = (e) => {
                    if (e.key === "Enter" || e.key === " " || e.code === "Space") {
                        e.preventDefault();
                        if (quizPage) {
                            navigateToIndex(idx);
                        }
                    }
                };

                return (
                    <div
                        key={q.uniqueId}
                        role="button"
                        tabIndex={0}
                        aria-label={`Gå til spørsmål ${idx + 1}`}
                        aria-current={isSelected ? "step" : undefined}
                        className={`${classes.dot} ${isSelected ? "selected" : ""}`}
                        onClick={handleClick}
                        onKeyDown={handleKeyDown}
                    />
                );
            })}
        </div>
    );
};
